import React from "react";
import "../css/paymentmodal.css";
import { succesBtnSvg } from "../assets/svg";
const AppointmentSuccess = () => {
  return (
    <div className="d-flex justify-content-center align-items-center success-parent">
      <div>
        <div className="d-flex justify-content-center">{succesBtnSvg()}</div>
        <div className="success-title">Your Appointment has been booked!</div>
        <div className=" d-flex  justify-content-center">
          <div className="success-btnn d-flex text-white" style={{cursor:"pointer"}} onClick={() => window.location.reload()}>OK</div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentSuccess;
